module.exports = __webpack_public_path__ + "img/roll6.2aeb1610.png";